import { render, staticRenderFns } from "./RentTypeAdd.vue?vue&type=template&id=82ee9bc8"
import script from "./RentTypeAdd.vue?vue&type=script&lang=js"
export * from "./RentTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./RentTypeAdd.vue?vue&type=style&index=0&id=82ee9bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports